import React, { Fragment, useEffect, useState } from 'react'
import { Form, InputGroup, Table } from 'react-bootstrap'
import product1 from '../../Assets/Images/product1.png'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import useCartDetail from '../../Hooks/Cart/useCartDetail'
import { applyCopoun } from '../../Services/CartServices'
import toast from 'react-hot-toast'
import Loader from '../Main/Loader'
import StripComp from '../Strip'
import { setGrandTotal } from '../../Redux/Slice/Checkout/checkoutSlice'


const OrderSummary = () => {

    const [
        cartItems,
        isLoading,
        code,
        handleDecreament,
        handleIncreament,
        handleRemove,
        totalAmount, // replace calculatePrice with totalAmount
        removeAll,
        handleSubmit,
        handleCode,
        discountAmount,
        totalAmountNumeric,
        user,
    ] = useCartDetail();

    const location = useLocation()


    return (

        <Fragment>
            <div className="row">
                <div className="col-lg-12">
                    <div className="bg-light p-3 card border-0">

                        <div className="card-body">

                            <p className='mb-0  s-19 '>
                                Order Summary
                            </p>


                            <hr />

                            {
                                cartItems?.cart?.map((item, i) => {
                                    return (
                                        <div className="row align-items-center py-2">
                                            <div className="col-auto">
                                                <img src={item?.img} width={"81px"} height={"79px"} className='rounded-2' alt="" />
                                            </div>

                                            <div className="col ps-0">
                                                <div className="row " >
                                                    <div className="col">
                                                        <h5 className='s-17 mb-0'>
                                                            {item?.title?.substring(0, 10) || ""}...
                                                        </h5>
                                                    </div>
                                                    <div className="col-auto">
                                                        <h5 className='s-17 fw-500 mb-0'>
                                                            ${item?.price}
                                                        </h5>
                                                    </div>
                                                </div>

                                                <div className="row">
                                                    <div className="col-auto">
                                                        <p className='s-16 text-muted mb-0'>
                                                            Qty: {item?.quantity}
                                                        </p>
                                                    </div>
                                                    <div className="col-auto verticle-border p-0" />
                                                    <div className="col-auto">
                                                        <p className='s-16 text-muted mb-0'>
                                                            Varient: {item?.variant_name}
                                                        </p>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }

                            {
                                location.pathname === "/checkout" ? (<></>) :
                                    (
                                        <>

                                            <InputGroup className="my-3 mb-4">
                                                <Form.Control
                                                    className='p-3 border border-3 bg-transparent border-end-0'
                                                    placeholder="Add Coupon Code"
                                                    onChange={handleCode}
                                                    value={code}
                                                />
                                                <button onClick={handleSubmit} className='btn btn-danger border-0 rounded-3 w-25' id="basic-addon2">
                                                    {isLoading ? <Loader /> : "Apply"}
                                                </button>
                                            </InputGroup>

                                        </>
                                    )
                            }






                            <div className="row py-2">
                                <div className="col">
                                    <p className='mb-0 16px'>
                                        Sub Total
                                    </p>
                                </div>

                                <div className="col-auto">
                                    <p className='mb-0 16px'>
                                        ${totalAmount}
                                    </p>
                                </div>
                            </div>


                            <hr />

                            {discountAmount && (

                                <><div className="row py-2">
                                    <div className="col">
                                        <p className='16px mb-0'>
                                            Discount Amount
                                        </p>
                                    </div>

                                    <div className="col-auto">
                                        <p className='16px mb-0'>
                                            ${discountAmount}
                                        </p>
                                    </div>
                                </div><hr /></>
                            )}

                            <div className="row py-2">
                                <div className="col">
                                    <p className='16px mb-0'>
                                        Total
                                    </p>
                                </div>

                                <div className="col-auto">
                                    <p className='16px mb-0'>
                                        ${totalAmountNumeric - discountAmount}
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>


            </div >


            {
                location?.pathname != "/my-cart" && (

                    <div>
                        <h5 className='mb-4 mt-5'>Add Payment Detail</h5>

                        {/* <Form.Group className="mb-3 col-lg-12" controlId="formBasicEmail">
                                <Form.Control type="text" className='border-0' placeholder="Name on card" />
                            </Form.Group>
                            <Form.Group className="mb-3 col-lg-12" controlId="formBasicEmail">
                                <Form.Control type="text" className='border-0' placeholder="Card Number" />
                            </Form.Group>
                            <Form.Group className="mb-3 col-lg-6" controlId="formBasicEmail">
                                <Form.Control type="text" className='border-0' placeholder="CVC" />
                            </Form.Group>
                            <Form.Group className="mb-3 col-lg-6" controlId="formBasicEmail">
                                <Form.Control type="Email" className='border-0' placeholder="MM/YY" />
                            </Form.Group> */}

                        <StripComp />

                    </div>
                )
            }
        </Fragment >
    )
}

export default OrderSummary